import coreLanguages from "../i18n/core-languages.json" with { type: "json" };
import otherLanguages from "../i18n/other-languages.json" with { type: "json" };

// taken from old project, used in languageDetail and SpokenLanguagesSection
export const CORE_LANGUAGES = coreLanguages;
export const OTHER_LANGUAGES = otherLanguages;

export const i18nLocales = [
  "en",
  "de",
  "es",
  "es-CO",
  "es-MX",
  "es-US",
  "fr",
  "id-ID",
  "it",
  "ja-JP",
  "mr",
  "nl",
  "pt",
  "pt-BR",
  "th-TH",
  "tr",
  "zh-Hant-TW",
];

export const defaultLocale = "en";

export const LanguageSelectionValues = {
  "id-ID": "Indonesian (Indonesia)",
  "th-TH": {
    value: "แบบไทย (Thai)",
    font: "noto-th",
  },
  de: "Deutsch",
  en: "English",
  es: "Español",
  "es-CO": "Español (Colombia)",
  "es-MX": "Español (Mexico)",
  "es-US": "Español (United States)",
  fr: "Français",
  it: "Italiano",
  mr: {
    value: "मराठी (Marathi)",
    font: "noto-mr",
  },
  nl: "Nederlands",
  "ja-JP": {
    value: "日本語 (Japanese)",
    font: "noto-jp",
  },
  pt: "Português",
  "pt-BR": "Português (Brasil)",
  tr: "Türkçe",
  "zh-Hant-TW": {
    value: "中國傳統的 (Traditional, Taiwan)",
    font: "noto-zh",
  },
};

export const fontFamilyMapping = {
  "noto-th": "Noto Sans Thai",
  "noto-mr": "Noto Sans Devanagari",
  "noto-jp": "Noto Sans JP",
  "noto-zh": "Noto Sans TC",
};

export function getLanguageDisplayName(locale) {
  const entry = LanguageSelectionValues[locale];
  if (!entry) return locale;
  return typeof entry === "string" ? entry : entry.value;
}

export function getLanguageFont(locale) {
  const entry = LanguageSelectionValues[locale];
  return typeof entry === "object" ? entry.font : null;
}

export function getLanguageFontFamily(locale) {
  const fontKey = getLanguageFont(locale);
  return fontKey ? fontFamilyMapping[fontKey] : null;
}

export const languageNames = Object.fromEntries(
  i18nLocales.map((locale) => [locale, getLanguageDisplayName(locale)]),
);

export function normalizeLocale(locale) {
  if (locale == null) {
    return defaultLocale;
  }

  const normalized = String(locale).toLowerCase().replace(/_/g, "-");
  const exact = i18nLocales.find((l) => l.toLowerCase() === normalized);
  if (exact) return exact;

  const lang = normalized.split("-")[0];
  const byLang = i18nLocales.find((l) => l.toLowerCase().startsWith(lang));
  return byLang || defaultLocale;
}
